import { render, staticRenderFns } from "./groceryBagRecipeBlock.vue?vue&type=template&id=132ce1ba&"
import script from "./groceryBagRecipeBlock.vue?vue&type=script&lang=js&"
export * from "./groceryBagRecipeBlock.vue?vue&type=script&lang=js&"
import style0 from "./groceryBagRecipeBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports